import { NgModule, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { InputMaskModule } from 'primeng/inputmask';
import { UnhandledErrorHandler } from './error-handling/unhandled-error-handler';
import { MessageService } from 'primeng/components/common/messageservice';

import { FullDatePipe } from './full-date-time/full-date.pipe';
import { CrownConnectDataModule } from '../cc-data/cc-data.module';
import { AutoFocusDirective } from './auto-focus/auto-focus.directive';
import { InputFeedbackComponent } from './input-feedback/input-feedback.component';
import { EnterKeyDownDirective } from './enter-key-down/enter-key-down.directive';
import { NumericInputMaxLengthDirective } from './numeric-input-max-length/numeric-input-max-length.directive';

@NgModule({
	imports: [
		CrownConnectDataModule,
		FormsModule,
		CommonModule,
		DropdownModule,
		InputTextModule,
		InputMaskModule
	],
	declarations: [
		FullDatePipe,
		AutoFocusDirective,
		InputFeedbackComponent,
		EnterKeyDownDirective,
		NumericInputMaxLengthDirective
	],
	exports: [
		FullDatePipe,
		AutoFocusDirective,
		InputFeedbackComponent,
		EnterKeyDownDirective,
		NumericInputMaxLengthDirective
	],
	providers: [

	]
})
export class GlobalModule { }